import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  noDataCell: {
    '&.MuiTableCell-root': {
      paddingTop: 32,
      paddingBottom: 32,
    },
  },

  noDataText: {
    '&.MuiTypography-root': {
      color: Colors.Grey7,
      fontSize: 14,
    },
  },
}));

export default useStyles;
